import { useState } from "react";
import { useTranslation } from "react-i18next";
import EducationalConsultantRequests from "./educational-consultant-requests-component";
import SchoolsRequestsComponent from "./schools-requests-compnent";

function RequestsListComponent() {
  const { t } = useTranslation();
  const [activeButtonIndex, setActiveButtonIndex] = useState(1);
  return (
    <div className="flex flex-col mt-11 mobile:items-center">
      <div className="max-w-[1154px] laptop:max-w-[1100px] largeLaptop:max-[1120px] tablet:max-w-[1000px] w-screen mobile:max-w-[360px] mobile:w-screen h-[33px] border-b border-zinc-200 justify-start items-center gap-[41px] flex flex-row">
        <div
          className={`py-1 ${
            activeButtonIndex === 1 && "border-b-2 border-mint-500"
          } justify-start items-start gap-2.5 flex`}
        >
          <button
            onClick={() => setActiveButtonIndex(1)}
            className={`text-center ${
              activeButtonIndex === 1 ? "text-mint-500" : "text-zinc300"
            } text-base font-arRegular`}
          >
            {t("requests.component.schoolsRequests")}
          </button>
        </div>
        <div
          className={`py-1 justify-start ${
            activeButtonIndex === 2 && "border-b-2 border-mint-500"
          } items-start gap-2.5 flex`}
        >
          <button
            onClick={() => setActiveButtonIndex(2)}
            className={`text-center ${
              activeButtonIndex === 2 ? "text-mint-500" : "text-zinc300"
            } text-base font-arRegular`}
          >
            {t("requests.component.eduConsultantRequests")}
          </button>
        </div>
      </div>
      <div className="flex flex-col items-center mt-14">
        {activeButtonIndex === 1 && <SchoolsRequestsComponent />}
        {activeButtonIndex === 2 && <EducationalConsultantRequests />}
      </div>
    </div>
  );
}

export default RequestsListComponent;
